import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { UIError } from 'common/interfaces';
import { IStore, IUpdateStoreState } from 'common/interfaces/istore';
import _ from 'lodash';

const initialState: IUpdateStoreState = {
  loading: false,
  error: null,
  store: null,
  isUpdated: false,
};

const reducers = {
  setLoading: (state: IUpdateStoreState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },
  setError: (state: IUpdateStoreState, action: PayloadAction<UIError | null>) => {
    state.error = action.payload;
  },
  resetContext: (state: IUpdateStoreState) => {
    _.merge(state, initialState);
    // state = initialState;
  },

  setStore: (state: IUpdateStoreState, action: PayloadAction<IStore | null>) => {
    state.store = action.payload;
  },
  setUpdated: (state: IUpdateStoreState, action: PayloadAction<boolean | false>) => {
    state.isUpdated = action.payload;
  },
};

const updateStoreSlice = createSlice({
  name: 'IUpdateStoreState',
  initialState: initialState,
  reducers: reducers,
});

export default updateStoreSlice.reducer;
export const UpdateStoreActions = updateStoreSlice.actions;
